import moment from 'moment'
export const useLanguageSelectionStore = defineStore('languageSelectionStore', () => {
  const { setLocale } = useL10n()
  const { locale, loadLocaleMessages } = useI18n()
  const languageDialog = ref(false)
  const selectedLanguage = ref(locale.value)
  const userStore = useUserStore()
  const chatStore = useChatStore()

  const currentLanguage = computed(() =>
    languages.find((language) => language.code === locale.value)
  )

  const languages = [
    { name: 'Deutsch', code: 'de', flag: 'fi fi-de' },
    { name: 'English', code: 'en', flag: 'fi fi-gb' },
    { name: 'Română', code: 'ro', flag: 'fi fi-ro' },
    { name: 'Български', code: 'bg', flag: 'fi fi-bg' },
    { name: 'Slovenščina', code: 'sl', flag: 'fi fi-si' }
  ]

  const showLanguageDialog = () => {
    languageDialog.value = true
  }

  const changeLanguage = async () => {
    if (userStore.isLoggedInAsContact) {
      await useApi(`css/contacts/${userStore.contact.id}`, 'PUT', {
        'custom_fields_0.v_30': selectedLanguage.value
      })
    } else if (userStore.isLoggedIn) {
      await useApi(`contacts/${userStore.contactUserRelation}`, 'PUT', {
        'custom_fields_0.v_30': selectedLanguage.value
      })
    }

    await loadLocaleMessages(selectedLanguage.value)
    setLocale(selectedLanguage.value)
    locale.value = selectedLanguage.value
    languageDialog.value = false
    chatStore.currentLanguage = selectedLanguage.value

    moment.locale(selectedLanguage.value === 'de' ? 'de' : 'en')
  }

  return {
    changeLanguage,
    showLanguageDialog,
    languages,
    selectedLanguage,
    languageDialog,
    currentLanguage
  }
})
